// 活动

const arr = [
    // zHotel活动展示页
    {
        path: '/activity/zHotelDisplay',
        component: () => import(/* webpackChunkName:"activity-zHotelDisplay"*/'@/pages/activity/zHotelActivity/index.vue'),
        name: 'zHotelDisplay',
        meta: {
            title: 'zHotel',
        },
    },
    // 发券中心
    {
        path: '/activity/aplusDiscuss',
        component: () => import(/* webpackChunkName:"activity-aplusDiscuss"*/'@/pages/activity/aplusDiscuss/index.vue'),
        name: 'aplusDiscuss',
        meta: {
            title: 'Aplus调查局',
        },
    },
    // 移动的亚朵酒店(市场部和瑞弗的春节送用户回家的联合公益活动)
    {
        path: '/activity/goHome',
        component: () => import(/* webpackChunkName:"activity-goHome"*/'@/pages/activity/GoHome/index.vue'),
        name: 'aplusDiscuss1',
        meta: {
            title: '移动的亚朵酒店',
        },
    },
    // 新客转化
    {
        path: '/activity/newUserTransform',
        component: () => import(/* webpackChunkName:"activity-newUserTransform"*/'@/pages/activity/newUserTransform/index.vue'),
        name: 'newUserTransform',
        meta: {
            title: '新享好礼',
        },
    },
    // 安心住
    {
        path: '/share/peaceOfMindLive',
        component: () => import(/* webpackChunkName:"activity-peaceOfMindLive"*/'@/pages/activity/peaceOfMindLive/index.vue'),
        name: 'peaceOfMindLive',
        meta: {
            title: '返工房安心住',
        },
    },
    // 预售
    {
        path: '/share/openToBooking',
        component: () => import(/* webpackChunkName:"activity-openToBooking"*/'@/pages/activity/openToBooking/index.vue'),
        name: 'openToBooking',
        meta: {
            title: '亚朵云游计划',
            wxConfig: ['updateTimelineShareData', 'updateAppMessageShareData', 'hideMenuItems', 'showMenuItems'],
        },
    },
    // 预售
    {
        path: '/share/buyTogether',
        component: () => import(/* webpackChunkName:"activity-buyTogether"*/'@/pages/activity/openToBooking/buyTogether.vue'),
        name: 'buyTogether',
        meta: {
            title: '亚朵云游计划',
            wxConfig: ['updateTimelineShareData', 'updateAppMessageShareData', 'hideMenuItems', 'showMenuItems'],
        },
    },
    // 签到活动
    {
        path: '/signEveryDay',
        component: () => import(/* webpackChunkName:"activity-signEveryDay"*/'@/pages/activity/signEveryDay/index.vue'),
        name: 'signEveryDay',
        meta: {
            title: '签到集拼图',
            // wxConfig: ['updateTimelineShareData', 'updateAppMessageShareData', 'hideMenuItems', 'showMenuItems'],
        },
    },
    // 签到活动-拼图图册
    {
        path: '/signEveryDay/puzzleList',
        component: () => import(/* webpackChunkName:"activity-signEveryDay"*/'@/pages/activity/signEveryDay/puzzleList.vue'),
        name: 'signEveryDay/puzzleList',
        meta: {
            title: '拼图图册',
            // wxConfig: ['updateTimelineShareData', 'updateAppMessageShareData', 'hideMenuItems', 'showMenuItems'],
        },
    },
    // 签到活动-签到日历
    {
        path: '/signEveryDay/calendarDetail',
        component: () => import(/* webpackChunkName:"activity-signEveryDay"*/'@/pages/activity/signEveryDay/signCalendar.vue'),
        name: 'signEveryDay/calendarDetail',
        meta: {
            title: '签到日历',
            // wxConfig: ['updateTimelineShareData', 'updateAppMessageShareData', 'hideMenuItems', 'showMenuItems'],
        },
    },
    // 签到活动-奖励明细
    {
        path: '/signEveryDay/prizeList',
        component: () => import(/* webpackChunkName:"activity-signEveryDay"*/'@/pages/activity/signEveryDay/prizeList.vue'),
        name: 'signEveryDay/prizeList',
        meta: {
            title: '奖励明细',
            // wxConfig: ['updateTimelineShareData', 'updateAppMessageShareData', 'hideMenuItems', 'showMenuItems'],
        },
    },
    // 武汉地区酒店会员引流项目
    {
        path: '/activity/disperse',
        name: 'disperse',
        component: () => import(/* webpackChunkName:"activity-disperse"*/'@/pages/activity/memberDisperse/index.vue'),
        meta: {
            title: '亚朵ATOUR',
        },
    },
    // 京东plus活动
    {
        path: '/activity/jdplus/:channel',
        component: () => import(/* webpackChunkName:"activity-jdplus"*/'@/pages/activity/jdPlus/parent.vue'),
        redirect: { name: 'jdplusindex' },
        name: 'jdPlus',
        children: [
            {
                path: 'index',
                component: () => import(/* webpackChunkName:"activity-jdplus"*/'@/pages/activity/jdPlus/index.vue'),
                name: 'jdplusindex',
                meta: {
                    title: ' ',
                },
            },
            {
                path: 'authentication',
                component: () => import(/* webpackChunkName:"activity-jdplus"*/'@/pages/activity/jdPlus/authentication.vue'),
                name: 'jdplusAuthentication',
                meta: {
                    title: ' ',
                },
            },
            {
                path: 'suggestChains',
                component: () => import(/* webpackChunkName:"activity-jdplus"*/'@/pages/activity/jdPlus/suggestChains.vue'),
                name: 'jdPlusSuggestChains',
                meta: {
                    title: ' ',
                    wxConfig: ['updateTimelineShareData', 'updateAppMessageShareData', 'hideMenuItems', 'showMenuItems'],
                },
            },
            {
                path: 'rule',
                component: () => import(/* webpackChunkName:"activity-jdplus"*/'@/pages/activity/jdPlus/rule.vue'),
                name: 'jsplusRule',
                meta: {
                    title: ' ',
                },
            },
        ],
    },
    // 问卷调研
    {
        path: '/prizeQuestionnaire/:id',
        component: () => import(/* webpackChunkName:"activity-prizeQuestionnaire"*/'@/pages/activity/prizeQuestionnaire/parent.vue'),
        redirect: '/prizeQuestionnaire/index',
        name: 'prizeQuestionnaire',
        children: [
            {
                path: 'index',
                component: () => import(/* webpackChunkName:"activity-prizeQuestionnaire"*/'@/pages/activity/prizeQuestionnaire/index.vue'),
                name: 'prizeQuestionnaireIndex',
                meta: {
                    title: '用户问卷调查',
                },
            },
            {
                path: 'luckdraw',
                component: () => import(/* webpackChunkName:"activity-prizeQuestionnaire"*/'@/pages/activity/prizeQuestionnaire/luckDraw.vue'),
                name: 'prizeQuestionnaireLuckDraw',
                meta: {
                    title: '幸运抽奖',
                },
            },
        ],
    },
    {
        path: '/comAct/:id/',
        component: () => import(/* webpackChunkName:"activity-comAct"*/'@/pages/commonActivity/parent.vue'),
        redirect: { name: 'comActIndex' },
        name: 'comAct',
        children: [
            {
                path: 'index',
                component: () => import(/* webpackChunkName:"activity-comAct"*/'@/pages/commonActivity/index.vue'),
                name: 'comActIndex',
                meta: {
                    title: '亚朵ATOUR',
                },
            },
            {
                path: 'suggestChains',
                component: () => import(/* webpackChunkName:"activity-comAct"*/'@/pages/commonActivity/suggestChains.vue'),
                name: 'comActSuggestChains',
                meta: {
                    title: '周边游推荐',
                },
            },
            {
                path: 'rule',
                component: () => import(/* webpackChunkName:"activity-comAct"*/'@/pages/commonActivity/rule.vue'),
                name: 'comActRule',
                meta: {
                    title: '亚朵ATOUR',
                },
            },
        ],
    },
    // 通用抽奖活动
    {
        path: '/drawReward/:id/',
        component: () => import(/* webpackChunkName:"activity-drawReward"*/'@/pages/commonActivity/drawReward/DrawReward.vue'),
        name: 'DrawReward',
        meta: {
            title: '幸运抽奖',
        },
    },
    // 售卡
    {
        path: '/activity/sellCard',
        component: () => import(/* webpackChunkName:"activity-sellCard"*/'@/pages/activity/sellCard/index.vue'),
        name: 'activity/sellCard',
        meta: {
            title: '',
            wxConfig: ['getBrandWCPayRequest'],
        },
    },
    // 售金卡季卡
    {
        path: '/activity/goldenSeason',
        component: () => import(/* webpackChunkName:"activity-goldenSeason"*/'@/pages/activity/sellCard/goldenSeason.vue'),
        name: 'activity/goldenSeason',
        meta: {
            title: '',
            wxConfig: ['getBrandWCPayRequest'],
        },
    },
    // 品牌聚合
    {
        path: '/brandAggregation',
        component: () => import(/* webpackChunkName:"activity-brandAggregation"*/'@/pages/activity/brandAggregation/index.vue'),
        name: 'brandAggregation',
        meta: {
            title: '',
        },
    },
    // 畅享生活体验卡
    {
        path: '/experienceCard',
        component: () => import(/* webpackChunkName:"activity-experienceCard"*/'@/pages/activity/experienceCard/index.vue'),
        name: 'experienceCard',
        meta: {
            title: '亚朵会员体验卡',
        },
    },
    // 会员体验卡二期
    {
        path: '/activity/experienceCardV2',
        component: () => import(/* webpackChunkName:"activity-experienceCardV2"*/'@/pages/activity/experienceCardV2/parent.vue'),
        name: 'experienceCardV2',
        redirect: { name: 'experienceCardV2Index' },
        children: [
            {
                path: 'index',
                component: () => import(/* webpackChunkName:"activity-experienceCardV2"*/'@/pages/activity/experienceCardV2/index.vue'),
                name: 'experienceCardV2Index',
                meta: {
                    title: '亚朵会员体验卡',
                },
            },
            {
                path: 'success',
                component: () => import(/* webpackChunkName:"activity-experienceCardV2"*/'@/pages/activity/experienceCardV2/success.vue'),
                name: 'experienceCardV2Success',
                meta: {
                    title: '亚朵会员体验卡',
                },
            },
        ],
    },
    // 1+n联名卡
    {
        path: '/activity/CoBrandCrad',
        component: () => import(/* webpackChunkName:"activity-CoBrandCrad"*/'@/pages/activity/CoBrandCrad/parent.vue'),
        redirect: { name: 'CoBrandCradIndex' },
        name: 'CoBrandCrad',
        children: [
            {
                path: 'index',
                component: () => import(/* webpackChunkName:"activity-CoBrandCrad"*/'@/pages/activity/CoBrandCrad/index.vue'),
                name: 'CoBrandCradIndex',
                meta: {
                    title: '亚朵联合会员',
                },
                beforeEnter: (to, from, next) => {
                    next({
                        path: '/activity/myMembership',
                        query: to.query,
                        params: to.params,
                    });
                },
            },
            {
                path: 'detail',
                component: () => import(/* webpackChunkName:"activity-CoBrandCrad"*/'@/pages/activity/CoBrandCrad/detail.vue'),
                name: 'CoBrandCradDetail',
                meta: {
                    title: '亚朵联合会员',
                },
            },
            {
                path: 'claim/:id',
                component: () => import(/* webpackChunkName:"activity-CoBrandCrad"*/'@/pages/activity/CoBrandCrad/claim.vue'),
                name: 'CoBrandCradClaim',
                meta: {
                    title: '权益领取',
                },
            },
            {
                path: 'rule/jd',
                component: () => import(/* webpackChunkName:"activity-CoBrandCrad"*/'@/pages/activity/CoBrandCrad/jdRule.vue'),
                name: 'CoBrandCradRule',
                meta: {
                    title: '协议',
                },
            },
            {
                path: 'rule/:id',
                component: () => import(/* webpackChunkName:"activity-CoBrandCrad"*/'@/pages/activity/CoBrandCrad/rule.vue'),
                name: 'CoBrandCradRule',
                meta: {
                    title: '协议',
                },
            },
            {
                path: 'personalInformationShareRule',
                component: () => import(/* webpackChunkName:"activity-CoBrandCrad"*/'@/pages/activity/CoBrandCrad/personalInformationShareRule.vue'),
                name: 'PersonalInformationShareRule',
                meta: {
                    title: '个人信息共享授权书',
                },
            },
        ],
    },
    {
        path: '/activity/askingActivity',
        component: () => import(/* webpackChunkName:"activity-askingActivity"*/'@/pages/activity/askingActivity/index.vue'),
        name: 'askingActivity',
        meta: {
            title: '用户调研问卷说明',
        },
    },
    {
        path: '/activity/pullNewMember',
        component: () => import(/* webpackChunkName:"activity-pullNewMember"*/'@/pages/activity/pullNewMember/index.vue'),
        name: 'pullNewMember',
        meta: {
            title: '会员拉新',
        },
    },
    {
        path: '/activity/pullNewMember/rule',
        component: () => import(/* webpackChunkName:"activity-pullNewMember"*/'@/pages/activity/pullNewMember/rule.vue'),
        name: 'pullNewMemberRule',
        meta: {
            title: '规则',
        },
    },
    // 永璞咖啡活动
    {
        path: '/activity/yongPuCoffee',
        component: () => import(/* webpackChunkName:"activity-yongPuCoffee"*/'@/pages/activity/foreverCoffee/parant.vue'),
        redirect: { name: 'foreverCoffee' },
        name: 'foreverCoffee',
        children: [
            {
                path: 'index',
                component: () => import(/* webpackChunkName:"activity-yongPuCoffee"*/'@/pages/activity/foreverCoffee/index.vue'),
                name: 'foreverCoffeeIndex',
                meta: {
                    title: '永璞咖啡活动',
                },
            },
            {
                path: 'tabDetails',
                component: () => import(/* webpackChunkName:"activity-yongPuCoffee"*/'@/pages/activity/foreverCoffee/tabDetails.vue'),
                name: 'foreverCoffeeTabDetails',
                meta: {
                    title: '永璞咖啡活动',
                },
            },
            {
                path: 'androidRouter',
                component: () => import(/* webpackChunkName:"activity-yongPuCoffee"*/'@/pages/activity/foreverCoffee/androidRouter.vue'),
                name: 'androidRouter',
                meta: {
                    title: '',
                },
            },

        ],
    },
    {
        path: '/activity/myMembership',
        component: () => import(/* webpackChunkName:"activity-myMembership"*/'@/pages/activity/myMembership/index.vue'),
        name: 'myMembership',
        meta: {
            title: '我的会员',
        },
    },
    {
        path: '/activity/rule',
        component: () => import(/* webpackChunkName:"activity-rule"*/'@/pages/activity/myMembership/rule.vue'),
        name: 'ActivityRule',
        meta: {
            title: '活动规则',
        },
    },
    // 京东
    {
        path: '/activity/JDCard',
        component: () => import(/* webpackChunkName:"activity-JDCard"*/'@/pages/activity/JDCard/index.vue'),
        name: 'activity/JDCard',
        meta: {
            title: '',
            wxConfig: ['getBrandWCPayRequest'],
        },
    },
    // 金+n联名卡
    {
        path: '/activity/goldNCard',
        component: () => import('@/pages/activity/goldNCard/parent.vue'),
        redirect: { name: 'goldNCardIndex' },
        name: 'goldNCard',
        children: [
            {
                path: 'index',
                component: () => import('@/pages/activity/goldNCard/index.vue'),
                name: 'goldNCardIndex',
                meta: {
                    title: '年末狂欢,买1得11',
                },
            },
            {
                path: 'openResult',
                component: () => import('@/pages/activity/goldNCard/openResult.vue'),
                name: 'goldNCardOpenResult',
                meta: {
                    title: '亚朵联合会员',
                },
            },
        ],
    },
    // 快速升保级
    {
        path: '/activity/promotion',
        component: () => import('@/pages/activity/promotion/index.vue'),
        name: 'promotion',
        meta: {
            title: '会员等级挑战活动',
        },
    },
    // 通用抽奖活动
    {
        path: '/miniappTransferPage',
        component: () => import('@/pages/commonActivity/miniappTransferPage.vue'),
        name: 'miniappTransferPage',
        meta: {
            title: '打开小程序',
        },
    },
];
export default arr;
